import { Tab, Tabs, withStyles } from "@material-ui/core";

const StyledTabs = withStyles({
    root: {
      minHeight: '25px',
      height: '100%', 
      transition: 'all 0.2s ease',
      width: '100%',
      borderBottom: '1px solidrgba(245, 0, 86, 0.24)'
    },
    indicator: {
      backgroundColor: '#0A74CB'
    },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);
  
const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    color: '#fff',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    minHeight: 'auto',
    minWidth: 'auto',
    opacity: 1,
    '&.MuiTab-root': {
      padding: '2px 12px',
      color: '#000',
      textTransform: 'capitalize',
      outline: 'none',
      fontSize: '13px',
      fontWeight: 500
    },
    '&:hover': {
      color: '#0A74CB',
      opacity: 1,
    },
    '&$selected': {
      color: '#00000',
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&:focus': {
      color: '#00000',
    },
  },
}))((props) => <Tab disableRipple {...props} />);


const HbxTabs = ({activeTab, onChange, tabs}) => {
    return(
        <StyledTabs value={activeTab} onChange={onChange} scrollable="auto" variant="scrollable">
            {
              tabs?.map(tab => (
                <StyledTab 
                  label={tab.label} 
                  data-ui-tour-id={tab.tourId || tab.label.toLowerCase().replace(/\s+/g, '-')} 
                  disabled={tab.isDisabled}
                />
            ))}
        </StyledTabs>
    )
}

export default HbxTabs;